import pathOr from 'ramda/src/pathOr';
import { EMPTY_ARRAY } from 'invision-core/src/constants/common.constants';
export var getBillerRuleInstanceThumbnailsWithCustomInformation = function getBillerRuleInstanceThumbnailsWithCustomInformation(updatedOption, existingOption) {
  updatedOption.BillerRuleInstanceThumbnails.forEach(function (brit) {
    var matchingBri = getMatchingOneTimeRecurringOrFinanceBriFromBrcId(updatedOption, brit.BillerRuleConfigurationId);
    if (matchingBri) {
      brit.hasAvailableDiscounts = !!pathOr(null, ['BillerRuleInstanceDiscounts', 'length'], matchingBri);
      brit.selectedDiscountsInfo = getSelectedDiscountsInfo(updatedOption, existingOption, brit.BillerRuleConfigurationId);
    }
    brit.Status = getBriStatus(updatedOption, brit.BillerRuleConfigurationId);
  });
  return updatedOption.BillerRuleInstanceThumbnails;
};
export var getMatchingOneTimeRecurringOrFinanceBriFromBrcId = function getMatchingOneTimeRecurringOrFinanceBriFromBrcId(option, brcId) {
  var oneTimeAndRecurringBris = pathOr([], ['PricingPlanBillerRuleInstances', 'RecurringBillerRuleInstances'], option).concat(pathOr([], ['PricingPlanBillerRuleInstances', 'OneTimeBillerRuleInstances'], option).concat(pathOr([], ['PricingPlanBillerRuleInstances', 'FinanceBillerRuleInstances'], option)));
  return oneTimeAndRecurringBris.find(function (bri) {
    return bri.BillerRuleConfigurationId === brcId;
  });
};
var getSelectedDiscountsInfo = function getSelectedDiscountsInfo(updatedOption, existingOption, brcId) {
  var allSelectedDiscountsInOption = pathOr(null, ['OfferingDecisionOptionInstances', 0, 'SelectedDiscounts'], updatedOption) || pathOr(null, ['OfferingDecisionOptionInstances', 0, 'SelectedDiscounts'], existingOption) || updatedOption.DefaultSelectedDiscounts || EMPTY_ARRAY;
  return allSelectedDiscountsInOption.filter(function (discount) {
    return discount.BillerRuleConfigurationId === brcId;
  }).map(function (discount) {
    return Object.assign({}, discount, {
      BillerRuleConfigurationId: brcId
    });
  });
};
var getBriStatus = function getBriStatus(option, brcId) {
  var briDetails = (option.BillerRuleInstanceThumbnails || []).find(function (bri) {
    return bri.BillerRuleConfigurationId === brcId;
  });
  return briDetails && briDetails.Status;
};